var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.156 14.294C8.899 12.76 12 9.626 12 6.75C12 5.1587 11.3679 3.63258 10.2426 2.50736C9.11742 1.38214 7.5913 0.75 6 0.75C4.4087 0.75 2.88258 1.38214 1.75736 2.50736C0.632141 3.63258 2.37122e-08 5.1587 0 6.75C0 9.626 3.1 12.76 4.844 14.294C5.16211 14.5779 5.5736 14.7349 6 14.7349C6.4264 14.7349 6.83789 14.5779 7.156 14.294ZM4 6.75C4 6.21957 4.21071 5.71086 4.58579 5.33579C4.96086 4.96071 5.46957 4.75 6 4.75C6.53043 4.75 7.03914 4.96071 7.41421 5.33579C7.78929 5.71086 8 6.21957 8 6.75C8 7.28043 7.78929 7.78914 7.41421 8.16421C7.03914 8.53929 6.53043 8.75 6 8.75C5.46957 8.75 4.96086 8.53929 4.58579 8.16421C4.21071 7.78914 4 7.28043 4 6.75Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.ec3862776538bceabcbc7f3370df340c.svg";
export { ForwardRef as ReactComponent };